import { useCallback } from 'react';
import { appendParams, finalizeUrl, getDefaultDeeplink } from '../utils';
import { useOpenDeeplink } from '../../../hooks';
import { useRootStackNavigation } from '../../../hooks/useRootNavigation';

type moveToMarketHomeProps = {
  sno: number;
  categorySno?: number | null;
  showCoupons?: boolean;
  order?: string | null;
  isDeeplink?: boolean;
};

export const useMarketNavigator = () => {
  const { openDeeplink } = useOpenDeeplink();
  const navigation = useRootStackNavigation();

  const moveToMarketHome = useCallback(
    ({
      sno,
      categorySno = null,
      showCoupons = false,
      order = null,
      isDeeplink = true,
    }: moveToMarketHomeProps) => {
      const url = getDefaultDeeplink();
      appendParams(url, 'screen', 'MarketHome');
      appendParams(
        url,
        'extras',
        JSON.stringify({
          category_sno: categorySno,
          show_coupons: showCoupons,
          order,
          sno,
        }),
      );
      if (isDeeplink) {
        openDeeplink(finalizeUrl(url));
      } else {
        navigation.push('MarketHome', {
          marketId: sno,
          extras: {
            category_sno: categorySno,
            show_coupons: showCoupons,
            order,
            sno,
          },
        });
      }
    },
    [navigation, openDeeplink],
  );

  return {
    moveToMarketHome,
  };
};
